import type { SalonProfile, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Aurum Salon & Beauty Studio',
    description: 'Premium hair, skin, nail, bridal and spa studio in Indiranagar, Bengaluru. Book online in under a minute with instant WhatsApp confirmation.',
    placeholder: 'Aurum Salon & Beauty Studio',
    url: getOrigin()
}

// Used only when the salon profile cannot be read from the database.
export const DEFAULT_PROFILE: SalonProfile = {
    id: '',
    name: siteConfig.name,
    short_name: 'Aurum',
    tagline: null,
    hero_eyebrow: null,
    hero_title: null,
    hero_title_accent: null,
    hero_subtitle: null,
    hero_image: null,
    hero_image_alt: null,
    about_title: null,
    about_story: null,
    about_image: null,
    about_image_alt: null,
    phone: null,
    whatsapp: null,
    email: null,
    address: null,
    area: null,
    city: null,
    state: null,
    pincode: null,
    map_query: null,
    open_time: '10:00',
    close_time: '20:30',
    closed_days: [],
    slot_minutes: 30,
    booking_window_days: 45,
    min_notice_minutes: 60,
    cancellation_notice_hours: 3,
    google_review_url: null,
    instagram_url: null,
    facebook_url: null,
    youtube_url: null,
    price_range: '₹₹₹',
    website_url: null
}

export const PUBLIC_NAV = [
    { href: '/services', label: 'Services' },
    { href: '/packages', label: 'Packages' },
    { href: '/gallery', label: 'Gallery' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]
